import { motion } from "framer-motion";

const processImages = [
  {
    title: "White Mercedes front view",
    slug: "white-mercedes-front",
    image: "https://customer-assets.emergentagent.com/job_d-detail-pro/artifacts/1j46cfbw_IMG_0081.jpeg",
  },
  {
    title: "White SUV side view",
    slug: "white-suv-side",
    image: "https://customer-assets.emergentagent.com/job_d-detail-pro/artifacts/xd1wejsx_IMG_0569.jpeg",
  },
  {
    title: "Shop interior with lighting",
    slug: "shop-lighting",
    image: "https://customer-assets.emergentagent.com/job_d-detail-pro/artifacts/gw8jv1qy_IMG_0695.jpeg",
  },
  {
    title: "Black Mustang outside shop",
    slug: "black-mustang",
    image: "https://customer-assets.emergentagent.com/job_d-detail-pro/artifacts/6t2f906e_IMG_0779.jpeg",
  },
  {
    title: "White Audi side view",
    slug: "white-audi",
    image: "https://customer-assets.emergentagent.com/job_d-detail-pro/artifacts/aluymmvv_IMG_1048.jpeg",
  },
];

export const AfterFormInfoSection = ({ callUrl, logoUrl, textUrl }) => {
  return (
    <section className="border-t border-white/10 py-24 md:py-32" data-testid="after-form-info-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div
          className="rounded-[2rem] bg-[#242424] p-6 shadow-[0_24px_70px_rgba(0,0,0,0.28)] sm:p-8"
          initial={{ opacity: 0, y: 28 }}
          transition={{ type: "spring", stiffness: 95, damping: 18 }}
          viewport={{ once: true, amount: 0.14 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          <div className="mx-auto flex max-w-[360px] flex-col items-center justify-center gap-4 rounded-[1.8rem] border border-white/10 bg-[#2e2e2e] px-6 py-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]" data-testid="after-form-logo-card">
            <div className="w-full max-w-[220px]" data-testid="after-form-logo-image-shell">
              <img
                alt="Detail With D full logo"
                className="after-form-logo-image block h-auto w-full object-contain"
                data-testid="after-form-logo-image"
                loading="lazy"
                src={logoUrl}
              />
            </div>
            <p className="text-center text-sm tracking-[0.2em] text-zinc-300" data-testid="after-form-logo-caption">
              Detail With D Window Tint
            </p>
          </div>

          <div className="mt-10 space-y-5" data-testid="after-form-copy-block">
            <h2 className="text-[clamp(2.6rem,6vw,4rem)] font-light leading-[0.95] text-white" data-testid="after-form-heading">
              What happens after you request a tint quote?
            </h2>
            <p className="max-w-5xl text-base leading-8 text-zinc-200 sm:text-[1.1rem]" data-testid="after-form-description">
              Once you complete the form, expect a follow-up from us shortly with your tint quote and next-step details. After you approve the quote, we will help schedule a convenient installation time at our Chicago shop so the process feels smooth, clear, and easy from the first message to the finished tint.
            </p>
          </div>

          <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="after-form-image-grid">
            {processImages.map((item) => (
              <div
                key={item.slug}
                className="overflow-hidden rounded-[1.35rem] border border-white/10 bg-black/20"
                data-testid={`after-form-image-card-${item.slug}`}
              >
                <img
                  alt={item.title}
                  className="h-[240px] w-full object-cover object-center sm:h-[260px]"
                  data-testid={`after-form-image-${item.slug}`}
                  loading="lazy"
                  src={item.image}
                />
              </div>
            ))}
          </div>

          <div className="mt-10 space-y-4" data-testid="after-form-contact-block">
            <h3 className="text-[2.1rem] font-medium leading-[1.02] text-white sm:text-[2.5rem]" data-testid="after-form-contact-heading">
              Contact Detail With D Window Tint
            </h3>

            <div className="space-y-3 text-base text-zinc-200 sm:text-[1.08rem]" data-testid="after-form-contact-lines">
              <p data-testid="after-form-contact-phone-line">
                <span className="font-semibold text-white">Phone:</span>{" "}
                <a className="text-zinc-200 hover:text-white" data-testid="after-form-contact-phone-link" href={callUrl}>
                  (773) 704-0795
                </a>
              </p>
              <p data-testid="after-form-contact-text-line">
                <span className="font-semibold text-white">Text:</span>{" "}
                <a className="text-zinc-200 hover:text-white" data-testid="after-form-contact-text-link" href={textUrl}>
                  Send your vehicle info and tint goals for a faster reply
                </a>
              </p>
              <p data-testid="after-form-contact-address-line">
                <span className="font-semibold text-white">Shop:</span> 9824 Industrial Dr, Bridgeview, IL 60455
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};